import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { storeData } from '@core/_utils/tools.utils';
import { ApiV6Service } from './apiv6.service';
import { lastValueFrom } from 'rxjs';
import { KeyDetailDocks } from '@documalis/_const/const';

interface GridItem {
    cols: number;
    rows: number;
    maxItemCols: number;
    minItemCols: number;
    minItemRows: number;
    id: string;
    display: boolean;
    x?: number;
    y?: number;
    label?: string;
}

@Injectable()
export class PanelService {
    public panelId: number = 0;
    public panelId_Docks: number = 0;
    public iddockuser: number = 0;
    private bskMode: boolean = false;
    public signEngineDock: boolean = false;
    private maxItemCols = 32;
    private minItemCols = 4;
    private minItemRows = 1;
    private colBase = 16;
    private savedDocks = [];
    public typeView = 2;
    private panelName = '';

    constructor(private api: ApiV6Service) {}

    public init(aBskMode, aCurrentSelectedBsk) {
        this.bskMode = aBskMode;
        this.panelName = this.getName(aCurrentSelectedBsk);        
        this.signEngineDock = false;
    }

    public async saveDock(aRightService, aSave, aDocumentDetail, aCurrentSelectedBsk, aBasketMoveAll) {
        let wRes: any;
        let wPanelMem = '';
        wPanelMem = this.getPanelMem(aSave, aDocumentDetail, aRightService, aBasketMoveAll);
        wRes = await this.execSaveDock(wPanelMem);
        return wRes;
    }

    private getName(aCurrentSelectedBsk) {
        let wName = KeyDetailDocks;
        if (this.bskMode === true) {
            wName = aCurrentSelectedBsk.bskName;
        }
        return wName;
    }

    private getPanelMem(aSave, aDocumentDetail, aRightService, aBasketMoveAll) {
        let wTab = [];
        if (aSave === true) {
            return JSON.stringify(aDocumentDetail.paramDetail.dockBase);
        } else {
            wTab = this.getPanelBase(aRightService,
                                    aDocumentDetail.paramDetail.currentSelectedBsk,
                                    aDocumentDetail.paramDetail.bskTypeMail,
                                    aDocumentDetail.paramDetail.infosMailDisplay,
                                    aDocumentDetail.paramDetail.displayBskVariableUpdate,
                                    aDocumentDetail.paramDetail.dockDyn, 
                                    aSave,
                                    aBasketMoveAll
                                    );
            return JSON.stringify(wTab);
        }
    }
   
    public getPanelBase(aRightService, aCurrentSelectedBsk, aBskTypeMail, aInfosMailDisplay, aDisplayBskVariableUpdate, aDockDyn, aSave, aBasketMoveAll) {
        let wTab = [];
        let wTabBase = [];     
        if (this.bskMode === false) {
            wTab = [...this.getPanelBaseDet(aRightService, null, null, null, null, '', aSave, aBasketMoveAll)];
        } else {
            wTab = [...this.getPanelBaseDet(aRightService,
                                         aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aSave, aBasketMoveAll)];
        }
        // Pas de mémorisation présente 
        if (this.panelId === 0 || aSave === false ) {
            wTabBase = this.getCommonPanel(aCurrentSelectedBsk);
            wTab = [...wTabBase,...wTab];
        }
        return wTab;
    }

    public getPanelBaseDet(aRightService, aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aSave, aBasketMoveAll) {
        let wPanelDock: any;
        let wPanelDefault = [];
        let wPanelMem = [];
        wPanelDock = JSON.parse(localStorage.getItem(this.panelName));
        this.panelId = wPanelDock.id;
        this.panelId_Docks = wPanelDock.id_docks;
        this.iddockuser = wPanelDock.iddockuser;

        wPanelDefault = this.getPanelDefault(aRightService, aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aBasketMoveAll);        
        if (wPanelDock.id === 0 || aSave === false) {
            return wPanelDefault;
        } else {
            // En cas de mémorisation, on met à jour les panels en vérifiant si de nouveaux panels doivent être rajoutés (nouveau droits ajoutés)
            wPanelMem = this.updatePanels(wPanelDock, aRightService, aDisplayBskVariableUpdate, aDockDyn, aCurrentSelectedBsk);
            wPanelDefault.forEach(item => {
                const index = wPanelMem.findIndex(elem => elem.id === item.id);
                if (index === -1) {
                    wPanelMem.push(item);
                }
            });
            if (wPanelDock.iddockuser === 0) {
                return this.computePosition(wPanelMem)
            } else {
                return wPanelMem;
            }
        }
    }

    private getPanelDefault(aRightService, aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aBasketMoveAll) {
        let wTab = [];
        if (this.bskMode === true) {
            wTab = this.getPanelBaseDetBsk(aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aBasketMoveAll);            
        }
        return [...wTab,...this.getPanelBaseDetail(aRightService)];
    }

    public getCommonPanel(aCurrentSelectedBsk) {
        let wTabBase = [];
        wTabBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockReorg', display: true});          
        if (this.typeView !== 3) {    
            wTabBase.push({cols: this.colBase, rows: 16, maxItemCols: this.maxItemCols, minItemCols: 5, minItemRows: this.minItemRows, id: 'dockVisu', display: true});     
        }
        if (this.bskMode === true) {    
            if (aCurrentSelectedBsk.bskApply === true || aCurrentSelectedBsk.bskType === 'btAction') {
                wTabBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: 1, minItemRows: this.minItemRows, id: 'dockButton', display: true});  
            }
        }  
        return wTabBase;
    }

    public resetPanel(aRightService, aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aBasketMoveAll) {
        let wTabBase = [];
        wTabBase = [...this.getCommonPanel(aCurrentSelectedBsk),...this.getPanelDefault(aRightService, aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aBasketMoveAll)];
        return wTabBase;
    }

    public savePanelDocks(aPanelDocks) {
        this.savedDocks = [];
        this.savedDocks = [...aPanelDocks];
    }

    public restorePanelDocks(aPanelDocks) {
        let wTabBase = [];
        if (this.savedDocks.length !== 0) {
            wTabBase = [...this.savedDocks];
            this.savedDocks = [];
            return wTabBase;
        } else {
            return aPanelDocks;
        }
    }

    public delDock(aPanelDock, aName) {
        let wPanel = [];
        wPanel = aPanelDock.filter((item) => {
            return item.id !== aName;
        })          
        return wPanel;
    }

    public resetPosition(wTabRes, aRightService, aBskTypeMail, aInfosMailDisplay,aCurrentSelectedBsk, aDisplayBskVariableUpdate,aBskDockDyn, aBasketMoveAll) {
        let wTab = [];
        let wTabBase = [];
        wTab = this.getPanelBaseDet(aRightService, aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aBskDockDyn, false, aBasketMoveAll);
        wTabBase = this.getCommonPanel(aCurrentSelectedBsk);
        wTab = [...wTabBase,...wTab];
        wTab = this.updateInfos(wTabRes, wTab);
        return wTab;
    }

    private updatePanels(aPanelDock, aRightService, aDisplayBskVariableUpdate, aDockDyn, aCurrentSelectedBsk) {
        let wPanel = <any>[];
        wPanel = JSON.parse(JSON.parse(aPanelDock.docks));
        for (let i = 0; i < wPanel.length; i++) {
            switch (wPanel[i].id) {
                case 'dockInfos': {
                    wPanel[i].display = aRightService.typeAction.TDInfo;
                    break;
                }
                case 'dockAtf': {
                    wPanel[i].display = aRightService.typeAction.TDAft;            
                    break;
                }
                case 'dockVar': {
                    wPanel[i].display = aRightService.typeAction.TDVar;
                    break;
                }
                case 'dockComment': {
                    wPanel[i].display = aRightService.typeAction.TDCom;
                    break;
                }
                case 'dockTrace': {
                    wPanel[i].display = aRightService.typeAction.TDTra;
                    break;
                }                
                case 'dockIndex': {
                    wPanel[i].display = aDisplayBskVariableUpdate;
                    break;
                }
                case 'dockVisu': {
                    wPanel[i].display = (this.typeView !== 3);
                    break;
                }
                case 'dockButton': {
                    wPanel[i].display = (aCurrentSelectedBsk.bskApply === true || aCurrentSelectedBsk.bskType === 'btAction');
                    break;
                }
                case 'dockSignEngine': {
                    wPanel[i].display = this.signEngineDock;
                    break;
                }
                case 'dockMail':
                case 'invoicevalidation':
                case 'maildispatching':
                case 'dockList': 
                case 'dockBskMove':
                case 'dockVersion':
                case 'dockReorg':
                {
                    wPanel[i].display = true;
                    break;
                }                
            }
        }
        if (this.bskMode === true) {            
            aDockDyn.forEach(item => {
                const index = wPanel.findIndex(elem => elem.id === item.name);
                if (index === -1) {                    
                    wPanel.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: item.name, label: item.label, display: true});                                   
                }
            });
        }
        wPanel = wPanel.filter(item => {
            return item.display === true;
        })
        return wPanel;
    }

    private getPanelBaseDetail(aRightService) {
        let wTab = <any>[];
        if (aRightService.typeAction.TDInfo) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockInfos', display: aRightService.typeAction.TDInfo});
        }
        if (aRightService.typeAction.TDAft) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockAtf', display: aRightService.typeAction.TDAft});
        }
        if (aRightService.typeAction.TDVar) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockVar', display: aRightService.typeAction.TDVar});
        }
        if (aRightService.typeAction.TDCom) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockComment', display: aRightService.typeAction.TDCom});
        }
        if (aRightService.typeAction.TDTra) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockTrace', display: aRightService.typeAction.TDTra});
        }
        if (aRightService.typeAction.TBList) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockList', display: aRightService.typeAction.TBList});
        }
        if (aRightService.typeAction.TGVer && this.bskMode === false) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockVersion', display: aRightService.typeAction.TGVer});
        }
        if (this.signEngineDock === true && this.bskMode === false) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockSignEngine', display: true});
        }
        return wTab;
    }

    private getPanelBaseDetBsk(aBskTypeMail, aInfosMailDisplay, aCurrentSelectedBsk, aDisplayBskVariableUpdate, aDockDyn, aBasketMoveAll) {
        let wTab = <any>[];
        if (aBskTypeMail === true && aInfosMailDisplay !== null) {
            wTab.push({cols: this.colBase, rows: 2, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockMail', display: true});
        }
        if (aCurrentSelectedBsk.bskTypeDock === 'InvoiceValidation') {
            wTab.push({cols: this.colBase, rows: 9, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'invoicevalidation', display: true});
        }
        if (aCurrentSelectedBsk.bskTypeDock === 'MailDispatching') {
            wTab.push({cols: this.colBase, rows: 9, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'maildispatching', display: true});
        }
        if (aCurrentSelectedBsk.bskTypeDock === 'MailValidation') {
            wTab.push({cols: this.colBase, rows: 9, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'mailvalidation', display: true});
        }
        if (aDisplayBskVariableUpdate) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockIndex', display: aDisplayBskVariableUpdate});
        }
        if (aDockDyn.length !== 0) {
            aDockDyn.forEach(element => {                
                wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: element.name, label: element.label, display: true});           
            });
        }
        if (aBasketMoveAll.length !== 0) {
            wTab.push({cols: this.colBase, rows: 4, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockBskMove', display: true});                       
        }
        return wTab;
    }   

    private async execSaveDock(aData) {
        let wRes: any;
        let wSuccess = true;
        let wRequestData: {};
        wRes = false;
        wRequestData = {
            id: this.panelId,
            id_docks: this.panelId_Docks,
            name: this.panelName,
            docks: JSON.stringify(aData),
            iddockuser: this.iddockuser
        };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('setdocks', wRequestData));
            wRequestData = {
                id: wRes.id,
                docks: wRes.data,
                iddockuser: wRes.iddockuser
            };
            storeData(this.panelName, JSON.stringify(wRequestData));
            this.panelId = wRes.id;
            this.iddockuser = wRes.iddockuser;
        } catch (error) {
            wSuccess = false;
        }
        return wSuccess;
    }
    
    public async resetDocks() {
        let wRes: any;
        let wSuccess: {
            success: boolean,
            docks: Array<any>
            details: boolean
        };
        let wRequestData: {};
        wRes = false;
        wRequestData = {
            id: this.panelId,
            name: this.panelName,
            iddockuser: this.iddockuser
        };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('resetdocks', wRequestData));
            if (wRes.data.length === 0) {
                wRequestData = {
                    id: 0,
                    docks: [],
                    iddockuser: 0
                };
                wSuccess = {success: true, docks: JSON.parse('[]'), details: false};
                this.panelId = 0;
                this.iddockuser = 0;
            } else {
                wRequestData = {
                    id: wRes.data[0].id,
                    docks: wRes.data[0].docks,
                    iddockuser: 0
                };
                wSuccess = {success: true, docks: JSON.parse(wRes.data[0].docks), details: true};
                this.panelId = wRes.data[0].id;
                this.iddockuser = wRes.data[0].iddockuser;
            }
            storeData(this.panelName, JSON.stringify(wRequestData));
        } catch (error) {
            wSuccess = {success: false, docks: [], details: false};
        }
        return wSuccess;     
    }

    private updateInfos(tableauA: GridItem[], tableauB: GridItem[]): GridItem[] {
        // Créer des ensembles d'IDs pour faciliter la comparaison
        const idsTableauA = new Set(tableauA.map(item => item.id));
        const idsTableauB = new Set(tableauB.map(item => item.id));

        // Créer des maps des éléments pour un accès rapide par id
        const mapTableauA = new Map<string, GridItem>();
        tableauA.forEach(item => {
            mapTableauA.set(item.id, item);
        });

        const mapTableauB = new Map<string, GridItem>();
        tableauB.forEach(item => {
            mapTableauB.set(item.id, item);
        });

        // 1. Filtrer le tableau A pour ne garder que les éléments présents dans B
        const elementsCommuns = tableauA
            .filter(item => idsTableauB.has(item.id))
            .map(itemA => {
                const itemB = mapTableauB.get(itemA.id)!;
                // Conserver les propriétés de A mais mettre à jour avec celles de B si nécessaire
                return {
                    ...itemB,  // Propriétés de base de B (cols, rows, etc.)
                    x: itemA.x,  // Conserver x de A pour l'instant
                    y: itemA.y,  // Conserver y de A pour l'instant
                    rows: itemA.rows,
                    // Utiliser le label de B s'il existe, sinon celui de A
                    label: itemB.label || itemA.label
                };
            });

        // 2. Ajouter les éléments de B qui ne sont pas dans A
        const elementsNouveaux = tableauB
            .filter(item => !idsTableauA.has(item.id))
            .map(itemB => {
                // Pour les nouveaux éléments, attribuer des coordonnées par défaut
                // On les placera à la fin de leur colonne respective
                return {
                    ...itemB,
                    x: 0,  // Valeur par défaut, sera mise à jour plus tard
                    y: 0   // Valeur par défaut, sera mise à jour plus tard
                };
            });

        // Combiner les éléments communs et nouveaux
        let elementsATraiter = [...elementsCommuns, ...elementsNouveaux];
        return this.execComputePosition(elementsATraiter);
    }

    private computePosition(elementsATraiter) {
        let result = [];
        let wItem: any;
        let resultat: GridItem[] = [];
        result = [...elementsATraiter];
        resultat = this.execComputePosition(elementsATraiter);

        result.map((item) => {
            wItem = resultat.filter((elem) => {
                return elem.id === item.id;
            });
            if (wItem !== null) {
                item.y = wItem[0].y;
                item.rows = wItem[0].rows;
            }
        });
        return result;
    }

    private execComputePosition(elementsATraiter) {
        // Résultat final
        const resultat: GridItem[] = [];
        // 3. Réorganiser les éléments par x pour la renumérotation
        const groupesParX = new Map<number, GridItem[]>();

        // Regrouper les éléments par valeur de x
        elementsATraiter.forEach(item => {
            // Utiliser 0 comme valeur par défaut pour x si non définie
            const x = item.x !== undefined ? item.x : 0;

            if (!groupesParX.has(x)) {
                groupesParX.set(x, []);
            }

            groupesParX.get(x)!.push(item);
        });

        groupesParX.forEach((elementsX, x) => {
            // Trier les éléments par leur valeur y actuelle pour maintenir un ordre relatif
            elementsX.sort((a, b) => {
                const yA = a.y !== undefined ? a.y : 0;
                const yB = b.y !== undefined ? b.y : 0;
                return yA - yB;
            });

            // Renuméroter les y en tenant compte de la hauteur (rows) des éléments précédents
            let positionY = 0;

            elementsX.forEach((item) => {
                const nouvelItem = {
                    ...item,
                    x: x,
                    y: positionY
                };

                // Mettre à jour positionY pour le prochain élément
                // Le prochain y sera égal au y actuel + rows de l'élément actuel
                positionY += item.rows;

                resultat.push(nouvelItem);
            });
        });
        return resultat;
    }

    public storeAfterReset(aDocks) {
        let wRequestData = {
            id: this.panelId,
            docks: JSON.stringify(aDocks),
            iddockuser: 0
        };
        storeData(this.panelName, JSON.stringify(wRequestData));
    }
}

